export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";